import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useUploadItemPhoto, useItemPhotos } from '@/hooks/item';
import { ItemPhotoUploadModal } from '@/types/modal';
import { ErrorModal, LoadingBodyModal, NoFooterModal, SuccessModal } from '@/components/molecules/common/Modal';

const View: React.FC<{ modal: ItemPhotoUploadModal }> = ({ modal }) => {
  const { t } = useTranslation();
  const { itemId, image, onClose } = modal;

  const photosR = useItemPhotos(itemId, false);
  const submitR = useUploadItemPhoto(itemId);

  useEffect(() => {
    if (submitR.kind === 'Completed') {
      photosR.refetch();
    }
  }, [submitR.kind]);

  useEffect(() => {
    submitR.mutate(image);
  }, []);

  if (submitR.kind === 'Error') {
    return (
      <ErrorModal
        title={t('modal.item_photo_upload.title')}
        error={submitR.error}
        onClose={onClose}
      />
    );
  } else if (submitR.kind === 'Completed') {
    return (
      <SuccessModal
        title={t('modal.item_photo_upload.title')}
        onClose={onClose}
      />
    );
  }

  const body = submitR.kind === 'Loading' ? <LoadingBodyModal height={40} /> : <></>;

  return (
    <NoFooterModal
      title={t('modal.item_photo_upload.title')}
      onClose={onClose}
      body={body}
      containerStyle={{ width: 500 }}
      modalName="item_photo_upload"
    />
  );
};

export default View;
